import { basic, initTopbar } from './modules/layouts';
import { initLocaleDatetime } from './modules/components';

initTopbar();
initLocaleDatetime();
basic();
